/** Modal de cadastro de nota fiscal */
import React, { Component } from "react";
import { Modal, Button, Icon, notification } from "antd";
import PropTypes from "prop-types";
import api from "../../../services/api";

export default class NotaFiscalCad extends Component {
  /**
   * Modal de cadastro de notas fiscais
   */
  state = {
    loading: false,
    visible: false,
    numero_nf: "",
    status_nf: "2"
  };

  UNSAFE_componentWillReceiveProps(props) {
    const visible = props.visible;

    this.setState({
      visible
    });
  }

  componentDidMount() {
    this.setState({
      visible: this.props.visible
    });
  }

  handleNotaFiscalCad = async () => {
    const numero_nf = this.state.numero_nf;
    const status = this.state.status_nf;

    this.setState({
      loading: true
    });

    await api
      .post("/notafiscal/", {
        parcela: this.props.parcela_id,
        numero_nf,
        status
      })
      .then(response => {
        notification.success({
          message: "Nota fiscal cadastrada."
        });

        /** Update parcela nota fiscal with new returned data */
        this.props.updateFunction(response.data);
      })
      .catch(error => {
        let message = "Ocorreu um problema ao tentar cadastrar a nota fiscal.";

        if (error.response) {
          if (error.response.status === 400) {
            if (error.response.data.numero_nf) {
              message = error.response.data.numero_nf[0];
            }
          }
        }

        notification.error({
          message
        });
      });

    this.setState({
      loading: false,
      visible: false
    });
  };

  handleNumeroNfChange = event => {
    const value = event.target.value;

    if (!/[^0-9]/g.test(String(value).toLocaleLowerCase())) {
      this.setState({
        numero_nf: value
      });
    }
  };

  handleStatusChange = event => {
    const value = event.target.value;

    this.setState({
      status_nf: value
    });
  };

  render() {
    return (
      <Modal
        confirmLoading={this.state.loading}
        visible={this.state.visible}
        title="Cadastrar nota fiscal"
        okText="Cadastrar"
        cancelText="Cancelar"
        onOk={this.handleNotaFiscalCad}
        onCancel={() => this.setState({ visible: false })}
      >
        <div>
          <div style={{ marginBottom: "10px" }}>
            <label>Número da nota:</label>
            <input
              type="text"
              className="ant-input"
              value={this.state.numero_nf}
              onChange={this.handleNumeroNfChange}
              style={{ marginTop: "6px" }}
            />
          </div>
          <div>
            <label>Status da nota:</label>
            <select
              value={this.state.status_nf}
              onChange={this.handleStatusChange}
              className="ant-input"
              style={{ marginTop: "6px" }}
            >
              <option value="2">Não conciliado</option>
              <option value="1">Conciliado</option>
            </select>
          </div>
        </div>
      </Modal>
    );
  }
}
NotaFiscalCad.propTypes = {
  visible: PropTypes.bool,
  parcela_id: PropTypes.number,
  updateFunction: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/Acordo/NotaFiscalCad/index.js